class Accordion {
    constructor() {
        document.querySelectorAll('.o-accordion-widget button').forEach(function(el){

            el.addEventListener("click", (event) => {
          
                var questionID = null;
          
                if(event.target.localName === 'header') {
                    //when span is clicked inside button add active to accordion button
                    if(event.target.parentElement.classList.contains("active")) {
                        event.target.parentElement.classList.remove("active");
                    } else {
                        event.target.parentElement.classList.add("active");
                    }
          
                    //when span is clicked inside button change aria-expanded to true/false
                    if(event.target.parentElement.ariaExpanded === "true") {
                        event.target.parentElement.ariaExpanded = "false";
                    } else {
                        event.target.parentElement.ariaExpanded = "true";
                    }
          
                    questionID = event.target.parentElement.id;
          
                } else {
                    //when button is clicked add active to accordion button
                    if(event.target.classList.contains("active")) {
                        event.target.classList.remove("active");
                    } else {
                        event.target.classList.add("active");
                    }
          
                    //when button is clicked change aria-expanded to true/false
                    if(event.target.ariaExpanded === "true") {
                        event.target.ariaExpanded = "false";
                    } else {
                        event.target.ariaExpanded = "true";
                    }
                    
                    questionID = event.target.id;
                }

                //Show Answer
                const answerID = questionID.replace('accordion', 'sect');
                const answerpanel = document.getElementById(answerID);

                if(answerpanel.classList.contains("active")) {
                    answerpanel.classList.remove("active");
                } else {
                    answerpanel.classList.add("active");
                }

                // Remove active class from all sibling elements
                const siblingQuestions = document.querySelectorAll('.o-accordion-widget button');
                siblingQuestions.forEach(function(sibling) {
                    const siblingQuestionID = sibling.id;
                    const siblingAnswerID = siblingQuestionID.replace('accordion', 'sect');
                    const siblingAnswerPanel = document.getElementById(siblingAnswerID);
                    
                    if (siblingQuestionID !== questionID) {
                        sibling.classList.remove('active');
                        sibling.ariaExpanded = "false"; // Update aria-expanded for siblings
                        siblingAnswerPanel.classList.remove('active');
                    }
                });
            });
        });
    }
}

export default Accordion;
